import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';

export type OauthThirdPartyFn = (payload: {
    request: {
        clientId: string;
        scope?: string;
        state: string;
        redirectUri: string;
        nonce: string;
        codeChallenge: string;
        codeChallengeMethod: string;
    };
    accessToken: string;
}) => Promise<unknown>;

export function initOauthThirdPartyFn({
    baseUrl,
}: {
    baseUrl: string;
}): OauthThirdPartyFn {
    const href = 'session/v1/oauth/auth-code';
    return async ({ request, accessToken }) => {
        const url = `${baseUrl}/${href}`;
        const response = await fetchWithAuthorization({
            url,
            method: 'POST',
            accessToken,
            body: request,
        });
        if (!response.ok) return Promise.reject(await response.json());
        return (await response.json()) as string;
    };
}
